import { render, staticRenderFns } from "./MatCursosMinisterioEgresado.vue?vue&type=template&id=1391275e&scoped=true&"
import script from "./MatCursosMinisterioEgresado.vue?vue&type=script&lang=js&"
export * from "./MatCursosMinisterioEgresado.vue?vue&type=script&lang=js&"
import style0 from "./MatCursosMinisterioEgresado.vue?vue&type=style&index=0&id=1391275e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1391275e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VChip,VDataTable,VIcon,VSpacer})
